// InvitesPage — the Invites tab merged into Members; keep this route as a redirect.
import { Navigate } from 'react-router-dom';
import { useOrgSlug } from '@/layouts/orgSettingsMeta';
import { paths } from '@/routes/paths';

export default function InvitesPage() {
  const slug = useOrgSlug();
  return <Navigate to={paths.org.members(slug)} replace />;
}
